/* eslint-disable no-undef */
import Image from 'global/Image';
import { TagWrapper } from './styled';

interface CorpActionTagProps {
  corpAction: Record<string, any>;
  isCorpActionBadges?: boolean;
  className?: string;
}

const CORP_ACTION_IMG = '/icon/corp_action_event_icon.svg';

function CorpActionTag({
  corpAction,
  className = '',
  isCorpActionBadges = false,
}: CorpActionTagProps) {
  const icon = corpAction?.icon || CORP_ACTION_IMG;
  const text = corpAction?.text || 'Corporate Action';

  return (
    // @ts-expect-error
    <TagWrapper className={className} isCorpActionBadges={isCorpActionBadges}>
      <Image alt={text} src={icon} />
    </TagWrapper>
  );
}

export default CorpActionTag;
